module.exports = __webpack_public_path__ + "static/icon-2months-23d28c8ff688ea3dee57889436d7038f.svg";